import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { ConfirmDialog } from 'src/app/models/common';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css']
})
@TraceClassDecorator()
export class ConfirmDialogComponent implements OnInit {
    @Input('data')
    data: ConfirmDialog;

    @Output('confirmAction')
    confirmAction: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() {}

    ngOnInit(): void {}

    cancel() {
        this.confirmAction.emit(false);
    }

    confirm() {
        this.confirmAction.emit(true);
    }
}
